import React from 'react';
import { pickPreviewImage, pickPreviewVideo, ShopMediaAsset } from '../utils/premiumBundleRules';

const checkerboard = 'bg-[repeating-conic-gradient(#333_0_25%,#222_0_50%)] bg-[length:12px_12px]';

/**
 * Still + animation preview for any wallet product: the thumbnail/image (or solid colour), and the
 * webm/mov played muted in a loop, the same way the product list and product form preview them.
 */
const ShopMediaPreview: React.FC<{ assets?: ShopMediaAsset[]; size?: number; showVideo?: boolean }> = ({
  assets = [],
  size = 64,
  showVideo = true,
}) => {
  const still = pickPreviewImage(assets);
  const video = showVideo ? pickPreviewVideo(assets) : null;
  const box = { width: size, height: size };

  if (!still && !video) {
    return (
      <div style={box} className='shrink-0 rounded border border-dashed border-white/20 flex items-center justify-center text-[10px] text-gray-500 text-center'>
        No media
      </div>
    );
  }

  return (
    <div className='flex items-center gap-1 shrink-0'>
      {still?.kind === 'color' && (
        <div style={{ ...box, backgroundColor: still.url }} className='rounded border border-white/10' title={still.url} />
      )}
      {still?.kind === 'image' && (
        <img src={still.url} alt={still.type} style={box} className={`rounded border border-white/10 object-contain ${checkerboard}`} />
      )}
      {video && (
        <video
          src={video.url}
          style={box}
          className={`rounded border border-white/10 object-contain ${checkerboard}`}
          autoPlay
          loop
          muted
          playsInline
        />
      )}
    </div>
  );
};

export default ShopMediaPreview;
